export default __webpack_public_path__ + "static/media/Logo.e3953c3b.svg";